import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import loadable from '@loadable/component';
import { PRODUCT_CLICK_LOCATION } from '@conversion/constants';
import getPriceWithDiscountAndPromotions from '@utils/price';
import PricePerMeasurementUnit from '@conversion/components/PricePerMeasurementUnit';
import Container from './components/Container';
import Title from './components/Title';
import Description from './components/Description';
import messages from './messages';

const ProductItemPrice = loadable(() => import('@components/ProductItemPrice'));

export function HighlightedProductDetails({
  product,
  isPriceFrom,
  intl,
  showDescription,
}) {
  const {
    name,
    price,
    description,
    priceWithDiscount,
    subsidizedProduct,
    pricePerMeasurementUnit,
    measurementUnit,
    discount,
    finalPriceWithoutTaxes,
  } = product;
  return (
    <Container>
      <Title id={PRODUCT_CLICK_LOCATION.NAME}>{name}</Title>
      {!!description && showDescription && (
        <Description>{description}</Description>
      )}
      {!!isPriceFrom && <span>{intl.formatMessage(messages.isPriceFrom)}</span>}
      <ProductItemPrice
        price={price}
        priceWithDiscount={getPriceWithDiscountAndPromotions({
          priceWithDiscount,
        })}
        subsidizedProduct={subsidizedProduct}
        discount={discount > 0}
        finalPriceWithoutTaxes={finalPriceWithoutTaxes}
      />
      <PricePerMeasurementUnit
        pricePerMeasurement={pricePerMeasurementUnit}
        measurementUnitId={measurementUnit?.id}
      />
    </Container>
  );
}

HighlightedProductDetails.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    applyDiscount: PropTypes.bool,
    price: PropTypes.number,
    priceWithDiscount: PropTypes.number,
    subsidizedProduct: PropTypes.object,
    pricePerMeasurementUnit: PropTypes.number,
    measurementUnit: PropTypes.shape({ id: PropTypes.number }),
    discount: PropTypes.number,
    finalPriceWithoutTaxes: PropTypes.number,
  }).isRequired,
  isPriceFrom: PropTypes.bool,
  showDescription: PropTypes.bool,
  intl: intlShape,
};

export default injectIntl(HighlightedProductDetails);
